var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcHomeOffice({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 68,
    viewBox: "0 0 70 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.38 0.98C34.96 0.68 34.48 0.5 33.97 0.5C33.46 0.5 32.98 0.68 32.56 0.98L0.25 26.18L3.04 29.72L7 26.66V54.5C7 55.7 7.48 56.84 8.32 57.68C9.16 58.52 10.3 59 11.5 59H26.44V54.5H11.5V23.15L34 5.6L64.96 29.75L67.06 27.08L67.75 26.21L35.38 0.98Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.24 31.49C32.35 31.49 30.79 33.02 30.79 34.94V56.48C30.79 58.37 32.32 59.93 34.24 59.93H44.26V63.8H38.89V68H61.93V63.8H56.56V59.93H66.58C68.47 59.93 70.03 58.4 70.03 56.48V34.94C70.03 33.05 68.5 31.49 66.58 31.49H34.24ZM48.46 63.8V59.93H52.33V63.8H48.46ZM65.8 35.69V55.73H34.99V35.69H65.8Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHomeOffice);
export default __webpack_public_path__ + "static/media/ic-home-office.df7c3ff2b8320c25497de1b677c56643.svg";
export { ForwardRef as ReactComponent };